import React from "react";
import { Box, Pagination, Typography } from "@mui/material";
import { C } from "../theme";

export default function ServicePagination({
  page,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
}) {
  if (totalPages <= 1) return null;

  const startItem = (page - 1) * itemsPerPage + 1;
  const endItem = Math.min(page * itemsPerPage, totalItems);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 1.5,
        px: 2,
        py: 1.5,
        borderTop: `1px solid ${C.border}`,
        bgcolor: "#fafafa",
        flexShrink: 0,
      }}
    >
      <Typography sx={{ fontSize: 13, color: C.textSoft, fontWeight: 600 }}>
        {startItem}–{endItem} de {totalItems}
      </Typography>
      <Pagination
        count={totalPages}
        page={page}
        onChange={(_, value) => onPageChange(value)}
        color="primary"
        shape="rounded"
        size="small"
      />
    </Box>
  );
}
